/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/require-default-props */
/* eslint-disable curly */
/* eslint-disable nonblock-statement-body-position */
import React, {
  InputHTMLAttributes,
  useRef,
  useEffect,
  useCallback,
  useState,
} from 'react';
import { IconBaseProps } from 'react-icons';
import { useField } from '@unform/core';
import * as Yup from 'yup';
import { Container, Error, Label } from './styles';

interface InputProps
  extends InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  label?: string;
  name: string;
  schema?: Yup.ObjectSchema;
  rounded?: boolean;
  icon?: React.ComponentType<IconBaseProps> | any;
  disabled?: boolean;
  cardtransfacil?: boolean;
  cardtransfacildigito?: boolean;
  multiline?: boolean;
  cpf?: boolean;
}

const Input: React.FC<InputProps> = ({
  name,
  label,
  rounded,
  schema,
  icon: Icon,
  cardtransfacil,
  cardtransfacildigito,
  children,
  disabled,
  multiline,
  cpf,
  ...rest
}) => {
  const inputRef = useRef<any>(null);

  const [isFocused, setIsFocused] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const { fieldName, defaultValue, error, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
    setIsFilled(!!inputRef.current?.value);
  }, []);

  const handleKeyUpCpf = useCallback(
    (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      e.currentTarget.maxLength = 14;
      let { value } = e.currentTarget;
      value = value.replace(/\D/g, '');
      value = value.replace(/(\d{3})(\d)/, '$1.$2');
      value = value.replace(/(\d{3})(\d)/, '$1.$2');
      value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      e.currentTarget.value = value;
    },
    [],
  );

  const handleKeyUpCardTransfacil = useCallback(
    (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      e.currentTarget.maxLength = 16;
      let { value } = e.currentTarget;
      value = value.replace(/\D/g, '');
      value = value.replace(/\D/g, '');
      value = value.replace(/^(\d{14})(\d)/, '$1-$2');
      e.currentTarget.value = value;
    },
    [],
  );

  const handleKeyUpCardTransfacilDigito = useCallback(
    (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      e.currentTarget.maxLength = 14;
      let { value } = e.currentTarget;
      value = value.replace(/\D/g, '');
      value = value.replace(/\D/g, '');
      e.currentTarget.value = value;
    },
    [],
  );

  const getHandleKeyUp = (
    e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    let handleFunction;
    if (cpf) handleFunction = handleKeyUpCpf(e);
    if (cardtransfacil) handleFunction = handleKeyUpCardTransfacil(e);
    if (cardtransfacildigito)
      handleFunction = handleKeyUpCardTransfacilDigito(e);
    return handleFunction;
  };

  const handleChange = useCallback(async () => {
    try {
      if (schema) {
        const isValid = await Yup.reach(schema, fieldName).validate(
          inputRef.current?.value,
          { abortEarly: true },
        );
        setIsCorrect(!!isValid);
      }
    } catch (err) {
      setIsCorrect(false);
    }
  }, [schema, fieldName]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <>
      <Label htmlFor={name}>{label}</Label>
      <Container
        isErrored={!!error}
        isFilled={isFilled}
        isFocused={isFocused}
        isCorrect={isCorrect}
        rounded={!!rounded}
        multiline={multiline}
      >
        {multiline && (
          <textarea
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            onChange={handleChange}
            onKeyUp={e => getHandleKeyUp(e)}
            defaultValue={defaultValue}
            ref={inputRef}
            {...rest}
          />
        )}

        {!multiline && (
          <input
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            onChange={handleChange}
            defaultValue={defaultValue}
            ref={inputRef}
            onKeyUp={e => getHandleKeyUp(e)}
            {...rest}
            disabled={disabled}
          />
        )}

        {children}
        {Icon && <Icon size={20} />}
      </Container>
      {!!error && <Error>{error}</Error>}
    </>
  );
};

export default Input;
